export default "__VITE_ASSET__95b1c958__"